import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import "./../node_modules/leaflet/dist/leaflet.css";
import "./../node_modules/leaflet.awesome-markers/dist/leaflet.awesome-markers.css";
import "./../node_modules/leaflet.locatecontrol/dist/L.Control.Locate.min.css";
import "./../node_modules/leaflet-draw/dist/leaflet.draw.css";
// import './../node_modules/leaflet-routing-machine/dist/leaflet-routing-machine.css'
import "./../node_modules/@fortawesome/fontawesome-free/css/all.css";
import boy from "./assets/boy.svg";
import EventBus from "./eventBus";
import UUID from "vue-uuid";
Vue.use(UUID);
import { uuid } from "vue-uuid";
// import 'body-scroll-lock' // don't let body scroll
import VBodyScrollLock from "v-body-scroll-lock";
Vue.use(VBodyScrollLock);
import VueGeolocation from "vue-browser-geolocation";
Vue.use(VueGeolocation);
import VueCookie from "vue-cookie";
Vue.use(VueCookie);
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
import Transitions from "vue2-transitions";
Vue.use(Transitions);
// import Vue100vh from "vue-div-100vh";
// Vue.use(Vue100vh);
// import DisableAutocomplete from 'vue-disable-autocomplete';
// Vue.use(DisableAutocomplete);
// import VueNativeNotification from 'vue-native-notification'
// Vue.use(VueNativeNotification, { requestOnNotify: true })
// Vue.notification.requestPermission().then(console.log) // Prints "granted", "denied" or "default"
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
const options = {
  // confirmButtonColor: '#41b882',
  // cancelButtonColor: '#ff7674',
  animation: false,
};
Vue.use(VueSweetalert2, options);
import ToggleButton from "vue-js-toggle-button";
Vue.use(ToggleButton);
import VueObserveVisibility from "vue-observe-visibility";
Vue.use(VueObserveVisibility);
// import PortalVue from "portal-vue";
// Vue.use(PortalVue);
// import SocialSharing from "vue-social-sharing";
// Vue.use(SocialSharing);
// import { VueHammer } from 'vue2-hammer'
// Vue.use(VueHammer)
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(Loading);
import Ripple from "vue-ripple-directive";
Ripple.color = "rgba(230, 213, 138, 0.35)";
Ripple.zIndex = 0;
Vue.directive("ripple", Ripple); // adds ripple effect to any element on click: v-ripple

import LazyComponent from "v-lazy-component";
Vue.use(LazyComponent);

// import * as VueGoogleMaps from "vue2-google-maps";
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "AIzaSyBYOwhqakcxLQQLpljhkug2WsNSA02cqss",
//     libraries: "places" // required for Autocomplete other libs: 'drawing,visualization'
//   },
//   installComponents: true
// });
// TODO FIX BUN
import WebpPlugun from "vue-webp-plugin";
Vue.use(WebpPlugun);
// import FlagIcon from "vue-flag-icon";
// Vue.use(FlagIcon);
// TODO FIX BUN
// import CountryFlag from 'vue-country-flag'
// Vue.component('country-flag', CountryFlag)
import FBSignInButton from "vue-facebook-signin-button";
Vue.use(FBSignInButton);
import browserDetect from "vue-browser-detect-plugin";
Vue.use(browserDetect);
import Notifications from "vue-notification";
Vue.use(Notifications);
// import Chat from 'vue-beautiful-chat'
// Vue.use(Chat)
import VueImg from "v-img";
Vue.use(VueImg);
// import VueFriendlyIframe from 'vue-friendly-iframe';
// Vue.use(VueFriendlyIframe);
import { Datepicker, Timepicker, Field, Skeleton } from "buefy";
// import 'buefy/dist/buefy.css'
import "./../node_modules/buefy/dist/buefy.css";
Vue.use(Field);
Vue.use(Datepicker);
Vue.use(Timepicker);
Vue.use(Skeleton);
import MarqueeText from "vue-marquee-text-component";
Vue.component("marquee-text", MarqueeText);
import VueSVGIcon from "vue-svgicon";
Vue.use(VueSVGIcon, {
  isStroke: true,
});
import "./compiled-icons";
import Lightbox from "vue-easy-lightbox";
Vue.use(Lightbox);
import VueImgFallback from "v-img-fallback";
Vue.use(VueImgFallback, {
  loading: "https://miro.medium.com/max/3796/1*hi7euM223Sr-9PIi1Pk7ng.png",
  error: "https://miro.medium.com/max/978/1*pUEZd8z__1p-7ICIO1NZFA.png",
});
import VueDraggableResizable from "vue-draggable-resizable";
// optionally import default styles
// import 'vue-draggable-resizable/dist/VueDraggableResizable.css'
Vue.component("vue-draggable-resizable", VueDraggableResizable);
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-default.css";
// import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast, { position: "bottom", duration: 3000 });

// import VueConfirmDialog from "vue-confirm-dialog";
// Vue.use(VueConfirmDialog);
// Vue.component("vue-confirm-dialog", VueConfirmDialog.default);
// TODO Replace with a working alternative or comment out for now

// import PouchDB from "pouchdb";
// Vue.use(PouchDB);

// import VueMeta from "vue-meta";
// Vue.use(VueMeta);

import push from "@/firebase-mixin";

import { languages } from "./locales/languages.js";

import store from "./store";
import date from "@/date";
import helpers from "@/helpers";

import vuexI18n from "vuex-i18n";
Vue.use(vuexI18n.plugin, store, { warnings: false });
Vue.i18n.add("en", languages.en);
Vue.i18n.add("th", languages.th);
Vue.i18n.set("en"); // set the start locale to use
Vue.i18n.fallback("en");

import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill(); // start the polyfill (for category scroll behavior)

VueCookies.config(Infinity); // expiry, does this really work? was '100d'

import { clearCache, debounce } from "./functions";

// Import the main Sass manifest file
import "./assets/main.scss";

Vue.config.productionTip = false;
Vue.config.performance = import.meta.env.NODE_ENV !== "production";

// probably could move to separate file (mixins.js) and import here
Vue.mixin({
  methods: {
    hostURL() {
      return import.meta.env.VITE_HOST + "/"; // e.g. https://tukapp.co/
    },
    log(eventName, data) {
      this.$store.dispatch("logEvent", { event: eventName, data: data });
    },
    isTablet() {
      console.log("isTablet", window.innerHeight, window.innerWidth);
      return window.innerHeight < window.innerWidth;
    },
    clearQuery() {
      // url path clear query, reset query
      // check path to protect against duplicate route error
      if (this.$route.path !== this.$route.fullPath) {
        this.$router
          .replace(this.$route.path)
          .catch((err) => console.log("clearQuery err", err));
      }
    },
    clearURLQuery() {
      if (this.$route.path !== this.$route.fullPath) {
        this.$router.replace(this.$route.path); // clear the query
      }
    },
    timeAgo(dt) {
      if (!dt) return "Unknown time";
      var diff = new Date() - new Date(dt); // milliseconds
      var minsAgo = Math.round(diff / (1000 * 60));
      if (minsAgo <= 90) return `${minsAgo} ${this.$t("minutes-ago")}`;
      var hoursAgo = Math.round(diff / (1000 * 60 * 60));
      if (hoursAgo <= 36) return `${hoursAgo} ${this.$t("hours-ago")}`;
      var daysAgo = Math.round(diff / (1000 * 60 * 60 * 24));
      return `${daysAgo} ${this.$t("days-ago")}`; // returns string
    },
    hoursAgo(dt) {
      if (!dt) return 0;
      var hoursAgo = (new Date() - new Date(dt)) / (1000 * 60 * 60);
      return Math.round(hoursAgo); // returns int
    },
    minutesAgo(dt) {
      if (!dt) return 0;
      var minsAgo = (new Date() - new Date(dt)) / (1000 * 60);
      return `${Math.round(minsAgo)} ${this.$t("minutes-ago")}`; // returns string
    },
    secondsAgo(dt) {
      if (!dt) return 0;
      var secondsAgo = (new Date() - new Date(dt)) / 1000;
      return Math.round(secondsAgo); // returns int
    },
    goto(page) {
      if (!page) return;
      if (page[0] !== "/") page = "/" + page;
      page += "#force";
      this.$router.push(page).catch((err) => {
        console.error("goto error", err);
        location.reload();
      });
    },
    gotoDelay(page, delay) {
      if (!page) return;
      if (page[0] !== "/") page = "/" + page;
      page += "#force";
      if (!delay) delay = 300;
      setTimeout(() => {
        this.$router.push(page).catch((err) => {
          console.error("goto error", err);
          // location.reload();
        });
      }, delay);
    },
    loginOkay(msg) {
      // check if logged in, returns true if logged in else open login modal
      if (this.$store.getters.isLoggedIn) return true;
      this.updateLocation();
      if (!msg) msg = this.$t("login.please-login"); //"Please login"
      EventBus.$emit("OPEN_LOGIN_MODAL", msg);
      return false;
    },
    smsLoginOkay(msg, callback) {
      // check if logged in, else prompt SMS login
      if (this.$store.getters.isLoggedIn) return true;
      this.updateLocation();
      if (!msg) msg = this.$t("login.please-login"); //"Please login"
      var payload = { msg: msg, callback: callback };
      EventBus.$emit("OPEN_LOGIN_SMS_MODAL", payload);
      return false;
    },
    updateUser() {
      if (!this.$store.getters.isLoggedIn) return;
      this.$store
        .dispatch("updateUser")
        .then((res) => console.log("updateUser", res.data))
        .catch((err) => console.log("updateUser", err));
    },
    refreshPage() {
      location.reload();
    },
    goHome() {
      this.$router.push("/home").catch((err) => {
        this.console("push_home err:", err);
        // setTimeout(() => location.reload(), 2000);
      });
    },
    shortenString(s, n) {
      // return first n chars of s
      if (!s) return null;
      if (s.length < n + 3) return s; // check length+3 because of ellipsis
      return `${s.substring(0, n)}...`;
    },
    openNow(hours, tz) {
      // hours: string like "0830-1230, 1400-2000"
      if (!hours) return true;
      // if (!tz) tz = { timeZone: "Asia/Bangkok" }; // default
      // var now = new Date().toLocaleTimeString("en-GB", tz);
      // now = parseInt(now.replace(/:/g, "").slice(0, 4)); // "11:00:00" -> 1100
      var now = this.$date.getHHMM();
      var isOpen = false;
      hours = hours.replace(/\s/g, ""); // remove spaces
      hours = hours.replace(/:/g, ""); // remove colons
      hours = hours.replace(/\./g, ""); // remove colons
      hours.split(",").forEach((h) => {
        var start = parseInt(h.split("-")[0]);
        var stop = parseInt(h.split("-")[1]);
        if (stop == 0) stop = 2400;
        if (now >= start && now < stop) isOpen = true;
      });
      if (isOpen) return true;
      return false; // closed
    },
    openLanguageSelector() {
      EventBus.$emit("OPEN_LANGUAGE_MODAL");
    },
    infoAlert(name, obj) {
      // for showing info prettier than an alert()
      this.$swal({
        title: name,
        text: JSON.stringify(obj),
      });
    },
    thankYou(text) {
      this.$swal({
        title: this.$t("thank-you"),
        text: text,
        showConfirmButton: false,
        timer: 2000,
      });
    },
    success(msg) {
      this.$swal({
        title: this.$t("success"), //"Success!",
        text: msg,
        // showCloseButton: true,
        confirmButtonText: this.$t("okay"),
        type: "success",
      }); // could use timer to dismiss
    },
    displayModal(name) {
      this.console("displayModal", name);
      this.$el.querySelector(name).classList.add("is-active"); // name like: ".siilor-request-modal"
    },
    displayModalNext(name) {
      this.$nextTick(() => this.displayModal(name));
    },
    showComponent(name) {
      this.$el.querySelector(name).style.display = "block";
    },
    hideComponent(name) {
      this.$el.querySelector(name).style.display = "none";
    },
    isStartRelated() {
      // check if we're close to app start time, e.g. for apiError debugging
      var startTime = new Date(this.$store.state.initialisedAt);
      var since = (new Date().getTime() - startTime.getTime()) / 1000;
      console.log("time since start", since);
      if (since < 10) return true;
      return false;
    },
    apiError(err) {
      console.error("apiError", err);
      console.log("apiError", JSON.stringify(err));
      // console.warn("apiError URL", err.config.url);
      EventBus.$emit("DEBUG_ERR", { apiError: err });
      var url = "";
      if (err.config) url = err.config.url;
      if (err.message === "Network Error") {
        // Network Error usually means no internet, could also mean slow API
        if (err.config) {
          // url = err.config.url;
          var obj = {
            url: err.config.url,
            method: err.config.method,
            created_at: new Date(),
            is_start: this.isStartRelated(),
          };
          this.$store.commit("networkError", obj); // save to store
          return;
        }
        this.warningAlert(this.$t("network-error"));
        return; // shouldn't end up here anymore...
      }
      var msg = "Unknown Error";
      if (err.response) msg = err.response.data;
      if (err.err) msg = err.err; // local hack response err message
      var html = `<div style='text-align:left'>
        <p style='font-size:1.2em; margin-bottom:12px'>
        <i class="fa fa-dumpster-fire"></i>&nbsp;Uh oh!
        </p>
        <p style='color:grey; margin-bottom:10px'>Internet or technical issue<p/>
        <p><i style='color:grey; font-weight:550; opacity:0.7'>
        <i class="fa fa-server"></i>&nbsp;<i class="fa fa-chevron-right"></i>&nbsp;
        </i>
        <span style='color:#3273dc; font-weight:400; font-family: Consolas,monaco,monospace; font-size:0.9em'>
        ${msg}</span>
        </p>`;
      if (this.isSuperUser())
        html += `<p style='background-color:#eee; margin-top: 8px; padding:4px; border-radius:3px; font-size:0.8em; color:black'>${url}</p>`;
      html += `</div>`; // close html div
      this.$swal({
        html: html,
        showCloseButton: true,
        confirmButtonColor: this.bulmaColor("link"),
      });
      this.$store.dispatch("logError", { type: "api", error: err.toString() });
    },
    swalError(err) {
      // show error alert
      this.$swal({
        text: err.toString(),
        type: "warning",
      });
      this.$store.dispatch("logError", { type: "app", error: err.toString() });
    },
    warningAlert(msg) {
      // show warning alert
      this.$swal({
        html: msg, //text: msg,
        type: "warning",
      });
    },
    errorToast(msg, position, duration) {
      if (!position) position = "bottom";
      this.$toast.open({
        type: "error",
        message: msg,
        position: position,
        duration: duration,
      });
    },
    warningToast(msg, position, duration) {
      if (!position) position = "bottom";
      this.$toast.open({
        type: "warning",
        message: msg,
        position: position,
        duration: duration,
      });
    },
    successToast(msg, position, duration) {
      if (!position) position = "bottom";
      this.$toast.open({
        type: "success",
        message: msg,
        position: position,
        duration: duration,
      });
    },
    infoToast(msg, position, duration) {
      if (!position) position = "bottom";
      this.$toast.open({
        type: "info",
        message: msg,
        position: position,
        duration: duration,
      });
    },
    isFavorite(businessID) {
      if (this.$store.state.favorites.includes(businessID)) return true;
      return false;
    },
    // formatDateTZ(date) {
    //   var offset = date.getTimezoneOffset();
    //   date = new Date(date.getTime() + (offset * 60 * 1000));
    //   return date.toISOString().split('T') // returns date like YYYY-MM-DD
    // },
    checkFCMQuery() {
      var query = this.$route.query;
      if (query.apn) store.dispatch("setNotificationToken", query.apn);
    },
    checkRegionQuery() {
      var query = this.$route.query;
      if (query.r) {
        // force region if passed in query
        if (query.r === "cm") this.chooseCity("Chiang Mai"); // set region
        if (query.r === "bk") this.chooseCity("Bangkok"); // set region
        if (query.r === "sg") this.chooseCity("Singapore"); // set region
        if (query.r === "lb") this.chooseCity("Lisbon");
      }
      // var host = window.location.hostname;
      // if (host.includes("picante.")) or "lb.tuk"
    },
    chooseCity(city) {
      var coords = null; // could set default coords here
      switch (city) {
        case "Bangkok":
          coords = { lat: 13.7321, lon: 100.5696 };
          break;
        case "Chiang Mai":
          coords = { lat: 18.796143, lon: 98.979263 };
          break;
        case "Bagan":
          coords = { lat: 21.20129, lon: 94.908509 };
          break;
        case "Pakokku":
          coords = { lat: 21.33562, lon: 95.0171976 };
          break;
        case "Singapore":
          coords = { lat: 1.29027, lon: 103.851959 };
          break;
        case "Lisbon":
          coords = { lat: 38.71709, lon: -9.13926 };
          break;
      }
      this.$store.commit("setUserState", coords); // your fakeLocation
      this.$store.commit("setRegion", city);
    },
    // checkLangQuery(forceLang) {
    checkLangQuery() {
      // if (forceLang) this.setLang(forceLang, false);
      var query = this.$route.query;
      // console.log("checkLang", query.lang);
      if (query.lang) this.setLang(query.lang, true); // ios app and ad links will pass lang
      if (query.l) this.setLangShort(query.l, true); // could allow ?l=e, ?l=t, ?l=j for shorter link
      // added new language subdomains on 15 June
      var host = window.location.hostname;
      // legacy single -letter lang prefix
      if (host.includes("e.tuk")) this.setLang("en", true);
      if (host.includes("t.tuk")) this.setLang("th", true);
      if (host.includes("z.tuk")) this.setLang("zh", true);
      if (host.includes("j.tuk")) this.setLang("ja", true);
      // proper two-letter lang code prefix
      if (host.includes("en.tuk")) this.setLang("en", true);
      if (host.includes("th.tuk")) this.setLang("th", true);
      if (host.includes("zh.tuk")) this.setLang("zh", true);
      if (host.includes("ja.tuk")) this.setLang("ja", true);
      if (this.isPicante()) this.setLang("en", true);
    },
    setLang(lang, save) {
      // 2 letter code: 'en', 'th'
      Vue.i18n.replace(lang, languages[lang]); // update it
      Vue.i18n.set(lang); // set it
      if (save) {
        this.log("set_language", lang);
        // console.log('setLang SAVE', lang);
        this.$store.commit("setLanguage", lang);
      }
    },
    setLangShort(l, save) {
      if (l === "e") this.setLang("en", save);
      if (l === "t") this.setLang("th", save);
      if (l === "z") this.setLang("zh", save);
      if (l === "j") this.setLang("ja", save);
    },
    // goToTransport() {
    //   this.console("goToTransport", this.$store.getters.getUserLocation);
    //   if (!this.$store.getters.getUserLocation) {
    //     this.updateLocation();
    //     EventBus.$emit("OPEN_REGION_MODAL"); // pass "transport" later...
    //   } else {
    //     this.$router.push("/tuktuk");
    //   }
    // },
    goToEat() {
      if (!this.$store.getters.getUserLocation) {
        this.updateLocation();
        EventBus.$emit("OPEN_REGION_MODAL", "eat");
      } else {
        this.gotoDelay("eat");
      }
    },
    goToRide() {
      if (!this.$store.getters.getUserLocation) {
        this.updateLocation();
        EventBus.$emit("OPEN_REGION_MODAL", "ride");
      } else {
        this.gotoDelay("ride");
      }
    },
    goToSend() {
      if (!this.$store.getters.getUserLocation) {
        this.updateLocation();
        EventBus.$emit("OPEN_REGION_MODAL", "ride");
      } else {
        this.gotoDelay("/ride?type=send");
      }
    },
    // goToShop() {
    //   // should get user location first so we only show nearby shops
    //   // see code above in goToTransport
    //   this.$router.push("/shop");
    // },
    goToFlowerShop() {
      var businessID = "6fde6059-6c14-11eb-9ab2-96c15b56ceba"; // Les Fleurs Fac
      if (!this.isProduction())
        businessID = "fd61a162-7e05-11ea-83ed-0a61787b37f7";
      this.$store.commit("selectBusiness", businessID);
      this.$router.push(`/shop/${businessID}`);
    },
    goToMart() {
      var martID = this.$store.getters.getNearestMartID;
      if (martID) this.gotoDelay("shop/" + martID);
      else this.warningToast("Mart is not yet available in your area");
    },
    goToPayment(query) {
      this.$router.push(`/payment${query}`);
    },
    newUUID() {
      return uuid.v1();
    },
    capitaliseFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    isTUKQR(str) {
      if (str.startsWith("https://tukapp.co")) return true;
      if (str.startsWith("https://www.tukapp.co")) return true;
      return false;
    },
    setMobileNumber() {
      EventBus.$emit("OPEN_LOGIN_SMS_MODAL"); // could pass payload: {msg: "hi", callback: "SOMETHING"}
    },
    checkMobileNumber() {
      // check if user has mobile number
      if (this.$store.getters.getUserMobile) return true;
      this.setMobileNumber();
      return false;
    },
    setName(callback) {
      if (this.$store.getters.isDriver && this.$store.getters.realName) {
        var err = `Drivers cannot change names<br>Contact Support if you need help`;
        return this.infoToast(err, "top");
      }
      console.log("setName", callback);
      this.$swal({
        // title: this.$t("login.enter-name"), //"Enter your name",
        html: `<div style='text-align:left'>
          <p style='font-size:1.2em; margin-bottom:12px'>
          <i class='far fa-user'></i>&nbsp;
          ${this.$t("login.enter-name")}</p>
          <p>${this.$t("login.can-be-nickname")}</p>
          </div>`,
        input: "text",
        inputValue: this.$store.getters.realName,
        showCancelButton: false,
        showCloseButton: this.$store.getters.realName ? true : false,
        inputValidator: (val) => {
          if (!val) return this.$t("login.must-enter-name");
          if (val.length < 4) {
            return "Must be at least 4 characters.<br>If shorter add your second name.";
          }
          this.$store.dispatch("setRealName", val);
        },
      }).then((val) => {
        if (!val.value) return;
        if (callback) EventBus.$emit(callback);
        else this.loginSuccessAlert();
      });
    },
    checkProfilePic() {
      if (!this.$store.getters.isLoggedIn) return;
      if (this.$store.state.user.profile_pic_url !== "") return;
      if (this.isIOSApp()) return; // ios can't upload photo
      this.$swal({
        // title: this.$t("login.set-profile-pic"), //"Please set your profile pic",
        title: '<i class="fa fa-user-astronaut fa-2x" />',
        html: `<div style='font-size:1.5em'>${this.$t(
          "login.set-profile-pic"
        )}</div>`,
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: this.$t("okay"),
        confirmButtonColor: this.bulmaColor("success"),
        cancelButtonText: this.$t("later"),
      }).then((result) => {
        if (result.value) {
          this.$router.push("/profile?set_profile_pic=true").catch((err) => {
            console.error(err);
          });
          EventBus.$emit("SET_PROFILE_PIC");
        } else {
          console.warn("user did not set profile pic");
        }
      });
    },
    updateRoles(showLoader) {
      if (!this.$store.getters.isLoggedIn) return;
      if (showLoader) var loader = this.loadingDots();
      this.$store
        .dispatch("getRoles", this.$store.state.user.id)
        .catch((err) => this.apiError(err))
        .finally(() => {
          if (showLoader) loader.hide();
        });
    },
    vipSiilorRideDetails() {
      this.$swal({
        title: this.$t("passenger.vip-siilor-title"),
        text: this.$t("passenger.vip-siilor-text"),
      });
    },
    freeSiilorRideDetails() {
      this.$swal({
        title: this.$t("passenger.free-siilor-title"),
        text: this.$t("passenger.free-siilor-text"),
      });
    },
    normalSiilorRideDetails() {
      this.$swal({
        title: this.$t("passenger.normal-siilor-title"),
        text: this.$t("passenger.normal-siilor-text"),
      });
    },
    siilorDriverFareDetailsFree() {
      this.$swal({
        title: this.$t("driver.70-baht-title"),
        html: `${this.$t("driver.70-baht-text")}<br><br>${this.$t(
          "driver.pay-end-of-week"
        )}`,
      });
    },
    siilorDriverFareDetailsNormal() {
      this.$swal({
        title: this.$t("driver.20-baht-title"),
        html: `${this.$t("driver.20-baht-text")}<br><br>${this.$t(
          "driver.pay-end-of-week"
        )}`,
      });
    },
    pollLocation() {
      // need to be logged in and not already polling location
      if (
        !this.$store.getters.isLoggedIn ||
        this.$store.state.isPollingLocation
      )
        return;
      this.$store.commit("setPollingLocationBool", true);
      setInterval(() => {
        if (!this.$store.getters.isLoggedIn) {
          this.$store.commit("setPollingLocationBool", false); // if subsequently logged out skip
        } else {
          this.updateLocation();
        }
      }, 1000 * 15); // get location every 10 seconds
    },
    iosLocation(location) {
      if (!this.$store.getters.isLoggedIn) {
        this.$store.commit("setUserState", {
          // id: this.$store.state.user.id, // don't know user_id yet
          lat: location.lat,
          lon: location.lng,
          accuracy: location.accuracy,
        });
      } else {
        this.$store.dispatch("saveUserState", {
          id: this.$store.state.user.id,
          lat: location.lat,
          lon: location.lng,
          accuracy: location.accuracy,
        });
      }
    },
    commitLocation() {
      if (!this.$store.state.geolocationPrompted) return;
      this.$getLocation({ enableHighAccuracy: true, timeout: 1000 * 10 })
        .then((location) => {
          this.$store.commit("setUserState", {
            // id: this.$store.state.user.id, // don't know user_id yet
            lat: location.lat,
            lon: location.lng,
            accuracy: location.accuracy,
          });
        })
        .catch((err) => this.console("commit setUserState", err));
    },
    updateLocation() {
      if (!this.$store.state.geolocationPrompted) return;
      if (!this.$store.getters.isLoggedIn) return this.commitLocation();
      this.$getLocation({ enableHighAccuracy: true, timeout: 1000 * 5 })
        .then((location) => {
          this.$store.dispatch("saveUserState", {
            id: this.$store.state.user.id,
            lat: location.lat,
            lon: location.lng,
            accuracy: location.accuracy,
          });
        })
        .catch(() => this.updateLocationLowAccuracy());
    },
    updateLocationLowAccuracy() {
      if (!this.$store.getters.isLoggedIn) return;
      this.$getLocation({ enableHighAccuracy: false, timeout: 1000 * 10 })
        .then((location) => {
          this.$store.dispatch("saveUserState", {
            id: this.$store.state.user.id,
            lat: location.lat,
            lon: location.lng,
            // accuracy: location.accuracy,
          });
        })
        .catch(() => this.updateLocationFallback()); // trigger this first, since it doesn't rely on a promise
    },
    updateLocationFallback() {
      if (!this.$store.getters.isLoggedIn) return;
      if (!this.$store.state.userState) return;
      this.$store
        .dispatch("saveUserState", {
          id: this.$store.state.user.id,
          lat: this.$store.state.userState.lat,
          lon: this.$store.state.userState.lon,
          accuracy: this.$store.state.userState.accuracy,
        })
        .catch((err) => console.warn("updateLocationFallback error", err));
    },
    languageCode() {
      return this.$store.state.language || "en";
    },
    getAddress(addressType) {
      return this.$store.getters.getAddresses.find(
        (a) => a.address_type === addressType
      );
    },
    loadingDots(color) {
      var loaderColor = "gold";
      if (color) loaderColor = color;
      var loader = this.$loading.show({
        color: loaderColor, //"gold",
        loader: "spinner", // spinner, bars, dots
        canCancel: false, //true,
        height: 60,
        width: 120,
        onCancel: this.onCancel,
      });
      setTimeout(() => loader.hide(), 15000); // fallback timer
      return loader;
    },
    requestPushNotificationPermission() {
      this.console("requestPushNotificationPermission");
      push.initialise(this.$store);
    },
    requestPersistedStoragePermission() {
      if (navigator.storage && navigator.storage.persist) {
        navigator.storage.persist().then((isPersisted) => {
          console.log(`Persisted storage granted: ${isPersisted}`);
          var status = isPersisted ? "granted" : "denied";
          this.log("persisted_storage_permission", status);
          this.$store.commit("setStoragePersisted", isPersisted);
          this.$store.dispatch("saveDevice", this.golangTimestamp()); // save device again now that have IP address
        });
      }
    },
    updateTransactionsForDriver(showLoading) {
      var t0 = new Date();
      if (!this.$store.getters.getDriverRole) return;
      EventBus.$emit("DRIVER_LOADER", true);
      var workflowID = this.$store.getters.getDriverRole.workflow_id;
      var payload = { workflowID: workflowID, force: showLoading };
      this.$store
        .dispatch("getTransactionsForWorker", payload) //workflowID)
        .catch((err) => console.log("updateTransactionsForDriver error", err))
        .finally(() => {
          EventBus.$emit("DRIVER_LOADER", false);
          this.debugTimer("updateTransactionsForDriver", t0);
        });
      // now check for delivery driver transactions
      // this.updateTransactionsForDeliveryDriver(showLoading)
    },
    // not being used, because server side checks for deliveries at the same time as rides
    updateTransactionsForDeliveryDriver(showLoading) {
      var t0 = new Date();
      if (!this.$store.getters.getDeliveryDriverRole) return;
      if (showLoading) var loader = this.loadingDots();
      var workflowID = this.$store.getters.getDeliveryDriverRole.workflow_id;
      var payload = { workflowID: workflowID, force: showLoading };
      this.$store
        .dispatch("getTransactionsForWorker", payload) //workflowID)
        .catch((err) => console.log("updateTransactionsForDriver error", err))
        .finally(() => {
          if (showLoading) loader.hide();
          this.debugTimer("updateTransactionsForDeliveryDriver", t0);
        });
    },
    updateTransactionsForCustomer(showLoading) {
      var t0 = new Date();
      if (!this.$store.getters.isLoggedIn) return;
      if (showLoading) var loader = this.loadingDots();
      this.$store
        .dispatch("getTransactionsForCustomer")
        .catch((err) => console.error("updateTransactionsForCustomer", err))
        .finally(() => {
          if (showLoading) loader.hide();
          this.debugTimer("updateTransactionsForCustomer", t0);
        });
    },
    updateRecentTransactionsForCustomer() {
      this.$store
        .dispatch("getRecentTransactionsForCustomer")
        .catch((err) =>
          console.error("updateRecentTransactionsForCustomer", err)
        );
    },
    updateOngoingTransactionsForCustomer() {
      this.$store
        .dispatch("getOngoingTransactionsForCustomer")
        .catch((err) =>
          console.error("updateOngoingTransactionsForCustomer", err)
        );
    },
    updateCustomerOrders() {
      this.updateRecentTransactionsForCustomer();
      this.updateOngoingTransactionsForCustomer();
    },
    updateOngoingTransactionsForWorker() {
      this.$store
        .dispatch("getOngoingTransactionsForWorker")
        .catch((err) =>
          console.error("updateOngoingTransactionsForWorker", err)
        );
    },
    longPollCustomerTransactions() {
      this.console("initiate longPollCustomerTransactions");
      setInterval(() => {
        this.updateTransactionsForCustomer(false);
      }, 1000 * 120);
    },
    updateOrdersCommerceAgent() {
      var role = this.$store.getters.getCommerceAgentRole;
      if (!role) return;
      EventBus.$emit("ECOMMERCE_LOADER", true);
      var ongoing = "getOngoingTransactionsForCommerceAgent";
      this.$store
        .dispatch(ongoing, role.workflow_id)
        .catch((err) => console.error(ongoing, err))
        .finally(() => EventBus.$emit("ECOMMERCE_LOADER", false));
      var past = "getPastTransactionsForCommerceAgent";
      this.$store
        .dispatch(past, role.workflow_id)
        .catch((err) => console.error(past, err));
      // .finally(() => EventBus.$emit("FORCE_PAST_ORDERS")); // a hack to get past orders to update w/o reload...
    },
    updateOrdersFleetDispatcher() {
      var role = this.$store.getters.getDispatcherRole;
      if (!role) return;
      EventBus.$emit("DISPATCHER_LOADER", true);
      var ongoing = "getOngoingTransactionsForFleetDispatcher";
      this.$store
        .dispatch(ongoing, role.workflow_id)
        .catch((err) => console.error(ongoing, err))
        .finally(() => EventBus.$emit("DISPATCHER_LOADER", false));
      // var past = "getPastTransactionsForFleetDispatcher";
    },
    updateOrdersLogisticsAgent() {
      var role = this.$store.getters.getLogisticsAgentRole;
      if (!role) return;
      EventBus.$emit("LOGISTICS_LOADER", true);
      var ongoing = "getOngoingTransactionsForLogisticsAgent";
      this.$store
        .dispatch(ongoing, role.workflow_id)
        .catch((err) => console.error(ongoing, err))
        .finally(() => EventBus.$emit("LOGISTICS_LOADER", false));
      var past = "getPastTransactionsForLogisticsAgent";
      this.$store
        .dispatch(past, role.workflow_id)
        .catch((err) => console.error(past, err));
    },
    updateLogisticsAgentFleetWorkflows() {
      var role = this.$store.getters.getLogisticsAgentRole;
      if (!role) return;
      this.$store
        .dispatch("getWorkflows", role.business_id)
        .then((res) => {
          console.log("fleet workflows2", res.data);
          if (res.data)
            this.$store.state.logisticsAgentFleetWorkflows = res.data;
        })
        .catch((err) => this.apiError(err));
    },
    refreshTransport() {
      // pulls latest transport workflow to update stops on map
      var workflow = this.$store.state.selectedTransport;
      if (!workflow) return;
      this.$store.dispatch("getWorkflowByID", workflow.id).then((res) => {
        this.console("getWorkflowByID", res);
        // this.$store.commit("updateSelectedTransport", res);
        this.$store.commit("selectTransport", res);
      });
    },
    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result; //increment date by days int
    },
    ///////////////////// cpu benchmark functions //////////////////////
    benchmarkFunc(source) {
      var hash = 0;
      if (source.length === 0) return hash;
      for (var i = 0; i < source.length; i++) {
        var char = source.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32bit integer
      }
      return hash; // https://www.sitepoint.com/measuring-javascript-functions-performance/
    },
    median(sequence) {
      sequence.sort(); // note that direction doesn't matter
      return sequence[Math.ceil(sequence.length / 2)];
    },
    randomString(length) {
      var randomChars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var result = "";
      for (var i = 0; i < length; i++) {
        result += randomChars.charAt(
          Math.floor(Math.random() * randomChars.length)
        );
      }
      return result;
    },
    makeBenchmark() {
      var times = [];
      var strings = [];
      for (var i = 0; i < 10; i++) {
        strings.push(this.randomString(10000));
      }
      for (var i = 0; i < 10; i++) {
        var t0 = performance.now();
        this.benchmarkFunc(strings[i]);
        var t1 = performance.now();
        times.push(t1 - t0);
      }
      var microseconds = Math.round(this.median(times) * 1000);
      this.$store.commit("setCPUBenchmark", microseconds);
      // console.log('Median time', this.median(times).toFixed(4), 'milliseconds', times);
    },
    makeBenchmarkOld() {
      var times = [];
      var str = this.randomString(10000);
      for (var i = 0; i < 10; i++) {
        var t0 = performance.now();
        this.benchmarkFunc(str);
        var t1 = performance.now();
        times.push(t1 - t0);
      }
      // console.log('Median time', this.median(times).toFixed(4), 'milliseconds', times);
    },
    ///////////////////////////////////////////////////////////////////////
    debugTimer(name, t0) {
      var timer = new Date().getTime() - t0.getTime();
      var msg = `${name} ${timer}`;
      EventBus.$emit("DEBUG", msg);
      if (name === "updateTransactionsForCustomer") {
        this.$store.commit("setSystemSpeed", timer);
      }
    },
    updateAllWorkflows() {
      var t0 = new Date();
      this.$store
        .dispatch("getWorkflowsAll")
        .then((res) => console.log("updateAllWorkflows", res))
        .catch((err) => this.apiError(err))
        .finally(() => this.debugTimer("updateAllWorkflows", t0));
    },
    updateEateries(showWarning) {
      this.$store.dispatch("getEateriesNearby").catch(() => {
        this.log("no_nearby_eateries");
        if (showWarning) {
          this.warningToast(
            "Sorry 😕<br>We don't have eateries in your area yet",
            "top"
          );
        }
      }); //this.apiError(err))
    },
    updateMarts() {
      this.$store.dispatch("getMartsNearby").catch((err) => {
        console.log("getMartsNearby error", err);
        this.log("no_nearby_marts");
      });
    },
    updateTransport() {
      this.$store
        .dispatch("getTransportNearby")
        .catch((err) => this.apiError(err));
    },
    updateUserStops() {
      if (!this.$store.getters.isLoggedIn) return;
      this.$store.dispatch("getUserStops").catch((err) => this.apiError(err));
    },
    checkMessages() {
      this.$store
        .dispatch("getMessagesForUser")
        .catch((err) => console.error("checkMessages", err));
    },
    pollForMessages() {
      this.checkMessages();
      setTimeout(() => this.checkMessages(), 1000 * 60);
    },
    updateAddresses() {
      EventBus.$emit("ADDRESSES_LOADER", true);
      this.$store
        .dispatch("getUserAddresses")
        .then((res) => console.log("getUserAddresses", res))
        .catch((err) => console.error("getUserAddresses", err))
        .finally(() => EventBus.$emit("ADDRESSES_LOADER", false));
    },
    sendSuperuserNotification(msg) {
      this.$store.dispatch("sendMessageToWorkflow", {
        workflow_id: "TUK", //"b1364084-053e-11ea-a2df-ca246128f2f4",
        message: msg,
        type: "push", // send type: sms or push
      });
    },
    sendCommerceAgentNotification(workflowID, title, msg) {
      this.$store.dispatch("sendMessageToWorkflow", {
        workflow_id: workflowID,
        title: title,
        message: msg,
        type: "push", // send type: sms or push
      });
    },
    sendPushNotification(msg, userID) {
      this.$store.dispatch("sendMessageToUser", {
        user_id: userID,
        message: msg,
        type: "push", // send type: sms or push
      });
      // .then(() => this.thankYou("Your message has been sent to the driver"))
    },
    sendSMS(msg, phoneNumber) {
      this.$store.dispatch("sendMessageToUser", {
        phone_number: phoneNumber,
        message: msg,
        type: "sms",
      });
    },
    shortenLink(longURL, shortLinkID, validity) {
      this.$store
        .dispatch("createShortLink", {
          url: longURL,
          short_id: shortLinkID,
          validity: validity, // in minutes, 60*24 = 1 day
        })
        .then((res) => this.console("shortenLink success", res))
        .catch((err) => this.apiError(err));
    },
    currencySymbol(country) {
      if (country === "th") return "฿";
      if (country === "sg") return "$";
      if (country === "jp") return "¥";
      if (country === "id") return "Rp";
      if (country === "my") return "RM";
      if (country === "us") return "$";
      if (country === "mm") return "K";
      if (country === "ph") return "₱";
      if (country === "vn") return "₫";
      if (country === "kh") return "៛";
      if (country === "pt") return "€";
      return "฿"; // default baht symbol
    },
    convertEURtoSOL(euros) {
      return euros / 212;
    },
    convertEURtoSOLPretty(euros) {
      return this.convertEURtoSOL(euros).toFixed(4);
    },
    shareTUKApp() {
      if (!navigator.share) {
        console.log("native sharing not supported by this device");
        return;
      }
      navigator
        .share({
          title: "Check out TUK App",
          text: "Get TUK for your local business needs!",
          url: "https://tukapp.co/install",
        })
        .catch((err) => console.log("Error sharing", err));
    },
    loginSuccessAlert() {
      this.$swal({
        title: this.$t("login.success-title"),
        html: this.$t("login.success-text1") + " 🙏🏽",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    metersToKM(meters, decimals) {
      var km = meters / 1000;
      return km.toFixed(decimals);
    },
    distanceAlert() {
      this.$swal({
        type: "info",
        html: "This stop is too far away.<br>Please choose a stop within 400m.",
        showConfirmButton: false,
        timer: 3000,
      });
    },
    translateByWeight(byWeight) {
      switch (byWeight) {
        case "per gram":
          return "/g";
        case "per 100 grams":
          return "/100g";
        case "per kg":
          return "/kg";
        default:
          return "/unk";
      }
    },
    translateTransportType(type) {
      switch (type) {
        case "Tuk Tuk":
        case "Public Tuk Tuk":
          return this.$t("transport.public-tuk-button");
        case "Private Tuk Tuk":
        case "Private":
          return this.$t("transport.private-tuk-button");
        case "Sii Lor":
          return this.$t("transport.local-tuk-button");
        case "Songthaew":
          return this.$t("transport.songthaew-button");
        case "Motorbike":
          return this.$t("transport.motorbike");
        case "Taxi":
          return this.$t("transport.taxi-button");
        case "VIP Taxi":
          return this.$t("transport.vip-taxi-button");
        default:
          return type; // fallthrough return original without translation
      }
    },
    translateAddressType(type) {
      return this.$t(`address.${type}`);
    },
    translateFulfilmentType(type) {
      return this.$t(`commerce.${type}`); // take-away or delivery
    },
    translateFulfilmentType2(type) {
      return this.$t(`commerce.${type}-2`); // take-away-2 or delivery-2
    },
    translateCategory(c) {
      if (!c) return null;
      var name = c.toLowerCase().replace(/\s+/g, "-"); // if multi-word how?
      return this.$t(`category.${name}`);
    },
    translateState(s) {
      if (!s) return null;
      s = s.toLowerCase().replace(/_/g, "-");
      return this.$t(`states.${s}`);
    },
    translatePayment(s) {
      if (!s) return null;
      var noTranslate = ["paynow"];
      if (noTranslate.includes(s.toLowerCase())) return s;
      s = s.toLowerCase().replace(/\s+/g, "-");
      return this.$t(`payment.${s}`);
    },
    translateZerosAs(zerosAs) {
      var lower = zerosAs.toLowerCase();
      return this.$t(`zeros-as.${lower}`);
    },
    translateRegion(s) {
      if (!s) return this.$t("geo.bangkok");
      var lower = s.toLowerCase().replace(/\s+/g, "-");
      return this.$t(`geo.${lower}`);
    },
    shortDateTime(timeString) {
      var dt = new Date(timeString);
      var date = dt.toLocaleString("en-GB").slice(0, 5);
      var time = dt.toLocaleTimeString("en-GB").slice(0, 5);
      return `${date}, ${time}`;
    },
    // for commerce settings closed_until to check if it's in the future
    isFutureTime(timeString) {
      if (!timeString) return false; // if null timeString
      return new Date(timeString) > new Date(); // true if time string is in future
    },
    debounce(action, seconds) {
      // just a wrapper around debounce func from functions.js
      return debounce(this.$store.commit, this.$store.state, action, seconds);
    },
    clearCacheAndReload() {
      this.log("app_update", this.$store.state.version);
      clearCache();
      this.$toast.open({
        message: this.$t("updating-app"),
        type: "info",
        position: "top",
        duration: 10000,
        dismissible: false,
      });
      EventBus.$emit("UPDATING_APP");
      window.iosClearCache(); // so Joe can clear the wk cache
      setTimeout(() => location.reload(), 1500);
    },
    fallbackProfPic() {
      return boy; // "./assets/no_profile_pic.png" "./assets/profile_pic_toucan.png"
    },
    profPic(user) {
      var defaultPic = this.$store.state.birdProfilePic; //"img/profile_pic_toucan.jpeg";
      if (!user) user = this.$store.state.user; // if user not passed to function then it's this user
      // if (user.profile_pic_url === '') return defaultPic
      return user.profile_pic_url || defaultPic;
    },
    isProduction() {
      return import.meta.env.VITE_TITLE === "Production";
    },
    console(s, o) {
      if (import.meta.env.VITE_TITLE === "Production") return; // no logs on production
      if (import.meta.env.VITE_TITLE === "Staging") return; // no logs on staging
      // if (import.meta.env.VITE_TITLE === "Local") return // no logs on local
      if (o) console.log(s, o);
      else console.log(s);
    },
    humanTime(t) {
      if (!t.data.scheduled_time) return "Now";
      var diff = new Date(t.data.scheduled_time) - new Date();
      if (diff > 1000 * 60 * 60 * 24) {
        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        return `In ${days} days`;
      }
      if (diff > 1000 * 60 * 60) {
        var hours = Math.floor(diff / (1000 * 60 * 60));
        return `In ${hours} hours`;
      }
      if (diff > 0) {
        var minutes = Math.floor(diff / (1000 * 60));
        return `In ${minutes} minutes`;
      }
      if (diff > -15) return "Now";
      return "Passed";
    },
    scheduledTime(t) {
      var dt = t.data.scheduled_time;
      if (!dt) return null;
      var opts = { hour: "2-digit", minute: "2-digit" };
      return new Date(dt).toLocaleTimeString([], opts);
    },
    longScheduledTime(t) {
      var options = {
        weekday: "short",
        // year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      var dt = t.created_at;
      if (t.data.scheduled_time) dt = t.data.scheduled_time;
      return new Date(dt).toLocaleString("en-GB", options);
    },
    hhmmTime(dt) {
      if (!dt) return;
      dt = new Date(dt); // convert it to date again just in case...
      var options = {
        hour: "2-digit",
        minute: "2-digit",
      };
      return dt.toLocaleTimeString("en-GB", options);
    },
    golangTimestamp() {
      return new Date().toISOString().replace("T", " ").substr(0, 19);
      // ISO8601 time: 2021-06-21T10:57:15.081Z converted to Golang UTC timestamp
    },
    updateTrips(showLoader) {
      this.updateRecentTransactionsForCustomer();
      this.updateOngoingTransactionsForCustomer();
      this.updateTransactionsForCustomer(showLoader);
      this.updateOngoingTransactionsForWorker();
    },
    // 9 June: changed swal to panel, 14 June turned off for now
    geolocationRequestModal() {
      // check if already has geolocation permission and don't ask again
      if (this.$store.getters.getUserLocation) return;
      // EventBus.$emit("GEOLOCATION_PROMPT"); // turn off for now
      this.$store.state.geolocationPrompted = true;
      this.commitLocation();
    },
    isMember(businessID) {
      return this.$store.state.roles.find((r) => r.business_id === businessID);
    },
    isSuperUser() {
      // return null;
      return this.$store.getters.isSuperUser;
    },
    isIOSApp() {
      var host = window.location.hostname;
      if (host.includes("ios.tuk")) return true;
      return false;
    },
    isAndroidApp() {
      // return true // no way to check this yet... implement android.tukapp.co
      return this.isInstalled();
    },
    isPicante() {
      if (this.$store.state.region === "Lisbon") return true;
      var query = this.$route.query;
      if (query.r === "lb") return true; // query version
      var host = window.location.hostname;
      return host.includes("picante.tuk"); // subdomain version
    },
    isInstalled() {
      return (
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone ||
        document.referrer.includes("android-app://")
      );
    },
    // isSafari() {
    //   var isSafariBrowser = this.$store.getters.getBrowser === "safari";
    //   return this.isIOSApp() || isSafariBrowser // for category scroll y
    // },
    isApp() {
      return this.isIOSApp() || this.isAndroidApp(); // check if Android also
    },
    roundUp(val, interval) {
      return Math.ceil(val / interval) * interval;
    },
    isWorkingDispatcher() {
      if (this.$store.state.workingState === "Dispatcher") return true;
      return false;
    },
    isSoundOn() {
      return this.$store.getters.isSoundOn;
    },
    userID() {
      if (!this.$store.state.user) return "";
      return this.$store.state.user.id; // should use getters.getUserID instead
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min; // 3-6, gives 3,4,5
    },
    enterPromoCode() {
      this.$swal({
        title: this.$t("promo.enter-code") + " 🎉",
        text: this.$t("promo.ask-driver"),
        input: "number",
        inputPlaceholder: "0123456789",
        confirmButtonText: this.$t("submit"),
        inputValidator: (val) => {
          if (!val || val.length < 6) return this.$t("promo.is-phone-number");
        },
      }).then((val) => {
        if (val.value) {
          var loader = this.loadingDots();
          this.$store
            .dispatch("checkPromoCode", val.value)
            .then((res) => {
              console.log("checkPromoCode", res);
              this.$store.commit("selectDriver", res.data.user_id);
              this.$store.commit("setReferralCode", val.value);
              this.thankYou(this.$t("promo.success")); //"Promo booking activated !!"
            })
            .catch((err) => {
              console.error("checkPromoCode", err);
              var invalid =
                this.$t("promo.invalid-code") +
                `<br><strong>${val.value}</strong><br><br>` +
                this.$t("promo.double-check") +
                " 🙏🏽";
              this.warningAlert(invalid);
            })
            .finally(() => loader.hide());
        }
      });
    },
    callPhoneNumber(phoneNumber) {
      this.$copyText(phoneNumber);
      this.infoToast("Copied " + phoneNumber);
      window.location.href = `tel:${phoneNumber}`;
    },
    isFirstRide() {
      return this.$store.state.rideCount === 0;
    },
    // converts a phone number from pure numbers to +66 international version
    convertPhoneNumber(str) {
      str = str.replace(/-|\s/g, "");
      if (str.startsWith("+")) return str; // should already be ok
      if (str.startsWith("00")) return "+" + str.substring(2);
      if (str.startsWith("0")) return "+66" + str.substring(1); // thai phone number
      this.console("convertPhoneNumber error", str);
      return str; // something's not right but return it anyway
    },
    bulmaColor(name) {
      if (name === "success") return "#35AC5E";
      if (name === "primary") return "#00D1B2";
      if (name === "link") return "#3273DC";
      if (name === "info") return "#209CEE";
      if (name === "warning") return "#FFDD57";
      if (name === "danger") return "#FF3860";
      if (name === "light") return "#F5F5F5";
      if (name === "dark") return "#363636";
      return "white";
    },
    myColor(name) {
      if (name === "verylightpink") return "#FFDCDC";
      if (name === "cardinal") return "#c41e3a";
      if (name === "crypto-primary") return "#8a02c3";
      if (name === "crypto-secondary") return "#00ffbd";
      return "white";
    },
    deepCopy(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    // compute price by weight, if applicable
    weightPrice(o) {
      if (!o.by_weight || !o.actual_weight) return o.price;
      var actualWeight = parseInt(o.actual_weight);
      switch (o.by_weight) {
        case "per gram":
          return actualWeight * o.price;
        case "per 100 grams":
          return (actualWeight * o.price) / 100;
        case "per kg":
          return (actualWeight * o.price) / 1000;
        default:
          return o.price;
      }
    },
    // applies discount to menu item price
    discountedPrice(o) {
      // handle price per kg
      var price = this.weightPrice(o);
      if (!o.discount) return parseInt(price);
      var discounted = parseInt(price) * (1 - o.discount / 100);
      if (o.discount_type === "number")
        discounted = parseInt(price) - o.discount; //number discount not allowed for by_weight prices
      if (discounted < 0) return 0; // shouldn't happen...
      return Math.round(discounted);
    },
    // adds the options to the discounted price
    discountedTotalPrice(o) {
      var add = 0; // add options price
      if (o.options) {
        o.options.forEach((s) => {
          // if (s.option) add += parseInt(s.option.price);
          if (s.option) add += this.optionPrice(s.option);
        });
      }
      // if (this.discountedPrice(o) + add < 0) return 0; // shouldn't happen...
      return this.discountedPrice(o) + add;
    },
    optionPrice(o) {
      var quantity = o.quantity || 1;
      return parseInt(o.discounted_price || o.price) * quantity;
    },
    // order item quantity taking into account out of stock
    actualQuantity(o) {
      var outOfStock = o.out_of_stock || 0;
      var quantity = o.quantity || 1;
      return quantity - outOfStock;
    },
    checkVersion() {
      var current = this.$store.state.version;
      this.$store
        .dispatch("checkVersion")
        .then((version) => {
          this.$store.commit("setInternetState", true);
          if (version === current) return; // up to date
          if (current === "0.0") {
            this.$store.commit("setVersion", version); //this.$store.state.version = version
            return; // new user set version
          }
          if (typeof version == "string") {
            // otherwise it's type number
            if (version.charAt(version.length - 1) === "f") {
              this.console(`Force update to version ${version}`);
              this.$store.commit("setVersion", version);
              this.clearCacheAndReload();
              return;
            }
          }
          console.warn(`New app version available: ${current} vs ${version}`);
          current = this.$store.getters.getCurrentVersionNumeric;
          // console.log("version - current", version - current);
          if (version - current > 0.02) {
            this.console(`Force update to version ${version} STALE`);
            this.$store.commit("setVersion", version);
            this.clearCacheAndReload();
            return;
          }
          // otherwise don't force update, prompt user to update
          this.$swal({
            title: this.$t("new-version-title"),
            text: `${this.$t("new-version-text")} v${version}`,
            confirmButtonText: this.$t("okay"),
          }).then((result) => {
            if (result.value) {
              this.$store.commit("setVersion", version);
              this.clearCacheAndReload();
            } else {
              console.warn(`User did not update app: ${current} vs ${version}`); // otherwise don't update
            }
          });
        })
        .catch(() => this.$store.commit("setInternetState", false));
    },
    localStorageSize() {
      var allStrings = "";
      for (var key in window.localStorage) {
        if (window.localStorage.hasOwnProperty(key)) {
          allStrings += window.localStorage[key];
        }
      }
      return allStrings
        ? 3 + Math.round((allStrings.length * 16) / (8 * 1024)) + " KB"
        : "Empty (0 KB)";
    },
    localStorageSizeArray() {
      var objects = JSON.parse(window.localStorage.store);
      var arr = [];
      for (var key in objects) {
        if (objects.hasOwnProperty(key)) {
          var str = JSON.stringify(objects[key]);
          var size = str
            ? 3 + Math.round((str.length * 16) / (8 * 1024)) + " KB"
            : "Empty (0 KB)";
          var num = str ? Math.round((str.length * 16) / (8 * 1024)) : 0;
          // console.log("check obj size:", key, size, str);
          arr.push([key, size, num]);
        }
      }
      arr.sort((a, b) => {
        if (a[2] === b[2]) return 0;
        else return a[2] < b[2] ? 1 : -1;
      });
      return arr;
    },
    showSystemStats() {
      setTimeout(() => this.makeBenchmark(), 500);
      var login = this.$store.state.loginMethod.toUpperCase();
      var region = this.$store.state.region;
      // var rideCount = this.$store.state.rideCount;
      var coords = this.$store.getters.getUserLocationString;
      var latency = this.$store.state.systemSpeed;
      var benchmark = this.$store.state.cpuBenchmark;
      var uuid = this.shortenString(this.$store.getters.getUUID, 6);
      var userID = this.shortenString(this.userID(), 6);
      var mobile = this.$store.getters.phoneNumber;
      var env = import.meta.env.VITE_TITLE;
      var version = this.$store.state.version;
      var nodes = document.getElementsByTagName("*").length;
      var speed = "not supported";
      if (navigator.connection) {
        speed = navigator.connection.downlink + " Mbps";
      }
      var localStorage = this.localStorageSize();
      // var compassHeading = Math.round(this.$store.state.compassHeading);
      var startURL = this.$store.getters.getStartURL;
      //<p>Ride Count <strong>${rideCount}</strong></p>;
      //<p>Compass <strong>${compassHeading}</strong></p>
      var ipAddress = null;
      if (this.$store.state.ipAddress) {
        var ip = this.$store.state.ipAddress;
        ipAddress = `${ip.ip}<br>${ip.city} ${ip.country} ${ip.region} ${ip.loc}`;
      }
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='font-size:1.5em; color:white; opacity:0.7; margin-bottom:8px'>
        <span style='color:#f5d252'>${env}</span> v${version}</p>
        <div style="font-size: 0.9em; color: #f5d252 !important;">
        <p>Host <strong>${import.meta.env.VITE_HOST}</strong></p>
        <p>IP Address <strong>${ipAddress}</strong></p>
        <p>Region <strong>${region}</strong></p>
        <p>Coords <strong>${coords}</strong></p>
        <p>UserID <strong>${userID}</strong> UUID <strong>${uuid}</strong></p>
        <p>Mobile <strong>${mobile}</strong></p>
        <p>Logged in via <strong>${login}</strong></p>
        <p>Download speed <strong>${speed}</strong></p>
        <p>API latency <strong>${latency} ms</strong></p>
        <p>CPU benchmark <strong>${benchmark} micro</strong></p>
        <p>DOM nodes <strong>${nodes}</strong></p>
        <p>localStorage <strong>${localStorage}</strong></p>
        <p>Start URL <strong>${startURL}</strong></p>
        </div></div>`,
        showCloseButton: true,
        showConfirmButton: false,
        customClass: { popup: "system-stats-swal", content: "ddd" },
      }).then((result) => {
        if (result.value) this.clearCacheAndReload();
      });
    },
    contactFBMessengerSupport() {
      window.open("https://m.me/tukapp", "_blank");
    },
    contactMerchantSupport() {
      window.open("https://m.me/tukcommerce", "_blank");
    },
    contactDriverSupport() {
      window.open("https://m.me/tukcommerce", "_blank");
    },
    startFakeGPS() {
      // var res = { coords: { latitude: 37.77, longitude: -122.42, accuracy: 1 } }
      var res = this.$store.state.fakeGPSLocation;
      navigator.geolocation.getCurrentPosition = (s) => s(res);
      // navigator.geolocation.watchPosition = (s) => s(res);
      navigator.geolocation.watchPosition = (s) => {
        // s(res);
        return 1; // return arbitrary watch ID
      }; //s(res);
      if (!res) return; // if never set fake gps before, e.g. Krit, probably do at top of this func
      this.$store.commit("setUserState", {
        lat: res.coords.latitude,
        lon: res.coords.longitude,
        accuracy: res.coords.accuracy,
      });
    },
    stopFakeGPS() {
      navigator.geolocation.getCurrentPosition =
        navigator.geolocation.realGetCurrentPostion;
      navigator.geolocation.watchPosition =
        navigator.geolocation.realWatchPostion;
    },
  },
});

/////////////////////////////////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////////////////////////////////

/* Global funcs for use by leaflet clicks */
window.clickConfirmPickup = () =>
  document.getElementById("confirm-pickup").click();
window.clickConfirmDropoff = () =>
  document.getElementById("confirm-dropoff").click();
window.selectDriver = (id) => {
  console.log("selectDriver", id);
  store.commit("selectDriver", id);
  Vue.$toast.open("Dispatch mode ON");
};
/* batch delivery leaflet clicks */
// window.selectBatchOrder = (ref) => EventBus.$emit("SELECT_BATCH_ORDER", ref);
window.dispatchDeliveryVehicle = (i) =>
  EventBus.$emit("DISPATCH_DELIVERY_VEHICLE", i);

window.iosLocation = (lat, lon, accuracy) => {
  var msg = `iOS location [ ${lat}, ${lon} ] ${typeof lat}`;
  EventBus.$emit("DEBUG", msg);
  var location = {
    lat: parseFloat(lat),
    lng: parseFloat(lon),
    accuracy: parseFloat(accuracy),
  };
  EventBus.$emit("UPDATE_IOS_LOCATION", location);
};

window.iosNotification = (notification) => {
  EventBus.$emit("DEBUG", `iOS notification raw: ${notification}`);
  EventBus.$emit(
    "DEBUG",
    `iOS notification stringified: ${JSON.stringify(notification)}`
  );
  // var obj = JSON.parse(notification)
  var msg = `iOS notification [ ${notification.title}, ${notification.body} ]`;
  EventBus.$emit("DEBUG", msg);
  EventBus.$emit("RECEIVED_IOS_NOTIFICATION", notification);
};

window.iosClearCache = () => console.log("iosClearCache");
window.iosClearCacheSuccess = () =>
  EventBus.$emit("DEBUG", "iosClearCacheSuccess");

window.leafletRouter = (route) => EventBus.$emit("LEAFLET_ROUTER_LINK", route);

window.pasteSpecialMessage = (txt) =>
  EventBus.$emit("PASTE_SPECIAL_MESSAGE", txt);

window.navigator.geolocation.realGetCurrentPostion =
  window.navigator.geolocation.getCurrentPosition;
window.navigator.geolocation.realWatchPostion =
  window.navigator.geolocation.watchPosition;
window.navigator.geolocation.isReal = true;

window.onbeforeunload = () => {
  // now saving $store.state only at app_destroyed and app_hidden, rather than at each mutation
  localStorage.setItem("store", JSON.stringify(store.state));
  EventBus.$emit("DESTROY_APP");
  return null; // to block popup on reload
};

// ***** code to implement for global event bus!! *****
// Vue.prototype.$e = EventBus; //new Vue(); // Global event bus
Vue.prototype.$date = date;
Vue.prototype.$h = helpers;

import shortid from "shortid";
Vue.prototype.$shortid = shortid;

import $Scriptjs from "scriptjs";
Vue.prototype.$scriptjs = $Scriptjs;

import PouchDB from "pouchdb";
Vue.prototype.$pouchdb = PouchDB;

// init stuff before vue app
// import manifests from "./manifests.js";
// var type = "staging";
// if (this.isProduction()) type = "production";
// manifests.create("staging");

new Vue({
  store, // inject store to all children
  router,
  render: (h) => h(App),
}).$mount("#app");

EventBus.$emit("DEBUG", "start app at " + new Date().toLocaleTimeString());

console.log("VITE_APP_TYPE:", import.meta.env.VITE_APP_TYPE);
// Update state in localStorage (as JSON string) on every mutation - note the 5MB limit on iOS
// store.subscribe((mutation, state) => localStorage.setItem('store', JSON.stringify(state)));
